export default {
    message: {
        title: 'MUSEU DEL BARROC ',
        preferVisitRead: '',
        preferVisitListten: '',
        preferVisitComplete: 'Completa',
        preferVisitShort: 'Corta',
        titleVisitType: 'Visitas guiadas',
        titleMenu: 'Menú',
        moreInfo:'¿Saber más?',
        moreInfoNo: 'No',
        moreInfoYes:'Sí',
        downloadAudio: '(descargar audios)',
        download: 'Descarga de los archivos de audio',
        errorDownload: 'Ha habido un error en al descarga.',
        cancelDownload: 'Has cancelado la descarga.',
        retry: 'Reintentar',
        noConnection: 'No tienes conexión a internet',
        titleMap: '',
        map: '',

      initDownload: 'Si us plau, espereu mentre es descarreguen els àudios',
      endDownload: 'Àudios descarregats. Gaudiu de la visita!',

        menuItems: [
            {
                img: 'barra_1.png',
                title: 'BENVINGUDA',
                map: '',
                author: '',
                imageMenu: '',
                imagesAudio: '',
                audio: '',
                menuSubItems: [
                    {
                        img: '',
                        imageMenu: 'sm_1.png',
                        title: 'BENVINGUDA',
                        author: '',
                        description: '',
                        audio: '1.mp3',
                        visitType: '{all}',
                        imagesAudio: [
                            {
                                img: '1a.jpg',
                                second: '0'
                            },
                            {
                                img: '1b.jpg',
                                second: '24'
                            },
                            {
                                img: '1c.jpg',
                                second: '27'
                            },
                        ],
                    },
                ],
            },
            {
                img: 'barra_2.png',
                title: 'LA PERLA RETROBADA',
                map: '',
                author: '',
                imageMenu: '',
                imagesAudio: '',
                audio: '',
                menuSubItems: [
                    {
                        img: '2a.jpg',
                        imageMenu: 'sm_2.png',
                        title: 'LA PERLA RETROBADA',
                        author: '',
                        description: '',
                        audio: '2.mp3',
                        visitType: '',
                    },

                    {
                        img: '3a.jpg',
                        imageMenu: 'sm_3.png',
                        title: 'AUTORETRAT',
                        author: '',
                        description: '',
                        audio: '3.mp3',
                        visitType: '',
                    },
                    {
                        img: '4a.jpg',
                        imageMenu: 'sm_4.png',
                        title: 'DESTRUCCIÓ I SALVAGUARDA',
                        author: '',
                        description: '',
                        audio: '4.mp3',
                        visitType: '{all}',
                    },
                    {
                        img: '5a.jpg',
                        imageMenu: 'sm_5.png',
                        title: 'LA CATALUNYA DEL BARROC',
                        author: '',
                        description: '',
                        audio: '5.mp3',
                        visitType: '{all}',
                    },


                ],
            },
            {
                img: 'barra_3.png',
                title: 'UNS SEGLES DAURATS',
                map: '',
                author: '',
                imageMenu: '',
                imagesAudio: '',
                audio: '',
                menuSubItems:
                    [
                        {
                            img: '6a.jpg',
                            imageMenu: 'sm_6.png',
                            title: 'UNS SEGLES DAURATS',
                            author: '',
                            description: '',
                            audio: '6.mp3',
                            visitType: '',
                        },
                        {
                            img: '7a.jpg',
                            imageMenu: 'sm_7.png',
                            title: 'JOAQUIM JUNCOSA',
                            author: '',
                            description: '',
                            audio: '7.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '7a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '7b.jpg',
                                    second: '65'
                                },
                                {
                                    img: '7c.jpg',
                                    second: '104'
                                },
                            ],
                        },
                        {
                            img: '8a.jpg',
                            imageMenu: 'sm_8.png',
                            title: 'JOSEP SUNYER',
                            author: '',
                            description: '',
                            audio: '8.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '8a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '8b.jpg',
                                    second: '22'
                                },
                                {
                                    img: '8c.jpg',
                                    second: '43'
                                },
                            ],
                        },
                        {
                            img: '9a.jpg',
                            imageMenu: 'sm_9.png',
                            title: 'ANTONI VILADOMAT',
                            author: '',
                            description: '',
                            audio: '9.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '9a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '9b.jpg',
                                    second: '108'
                                },
                                {
                                    img: '9c.jpg',
                                    second: '118'
                                },
                            ],
                        },
                    ],
            }
            ,
            {
                img: 'barra_4.png',
                title: 'ARTESANS I ARTISTES',
                map: '',
                author: '',
                imageMenu: '',
                imagesAudio: '',
                audio: '',
                menuSubItems:
                        [
                        {
                            img: '10a.jpg',
                            imageMenu: 'sm_10.png',
                            title: 'ARTESANS I ARTISTES',
                            author: '',
                            description: '',
                            audio: '10.mp3',
                            visitType: '',
                            imagesAudio: [
                                    {
                                        img: '10a.jpg',
                                        second: '0'
                                    },
                                    {
                                        img: '10b.jpg',
                                        second: '33'
                                    },
                                ],
                        },
                        {
                            img: '11a.jpg',
                            imageMenu: 'sm_11.png',
                            title: 'MÀSCARA REIAL',
                            author: '',
                            description: '',
                            audio: '11.mp3',
                            visitType: '',
                            imagesAudio: [
                                    {
                                        img: '11a.jpg',
                                        second: '0'
                                    },
                                    {
                                        img: '11b.jpg',
                                        second: '16'
                                    },
                                    {
                                        img: '11c.jpg',
                                        second: '39'
                                    },
                                    {
                                        img: '11d.jpg',
                                        second: '60'
                                    },
                                    {
                                        img: '11e.jpg',
                                        second: '81'
                                    },
                                    {
                                        img: '11f.jpg',
                                        second: '86'
                                    },
                                ],


                        },
                ],
            },

            {
                img: 'barra_5.png',
                title:'TEATRE DIVÍ',
                map:'',
                author: '',
                imageMenu: '',
                imagesAudio: '',
                audio: '',
                menuSubItems:
                    [
                        {
                            img: '',
                            imageMenu: 'sm_12.png',
                            title: 'TEATRE DIVÍ',
                            author: '',
                            description: '',
                            audio: '12.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '12a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '12b.jpg',
                                    second: '104'
                                },
                            ],
                        },
                        {
                            img: '',
                            imageMenu: 'sm_13.png',
                            title: 'DEVOCIÓ DEL ROSER',
                            author: '',
                            description: '',
                            audio: '13.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '13a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '13b.jpg',
                                    second: '55'
                                },
                            ],


                        },
                        {
                            img: '',
                            imageMenu: 'sm_14.png',
                            title: 'RETAULE DEL ROSER',
                            author: '',
                            description: '',
                            audio: '14.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '14a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '14b.jpg',
                                    second: '21'
                                },
                                {
                                    img: '14c.jpg',
                                    second: '38'
                                },
                                {
                                    img: '14d.jpg',
                                    second: '48'
                                },
                                {
                                    img: '14e.jpg',
                                    second: '56'
                                },
                                {
                                    img: '14f.jpg',
                                    second: '66'
                                },
                                {
                                    img: '14g.jpg',
                                    second: '81'
                                },
                                {
                                    img: '14h.jpg',
                                    second: '113'
                                },
                                {
                                    img: '14i.jpg',
                                    second: '121'
                                },
                                {
                                    img: '14j.jpg',
                                    second: '130'
                                },
                                {
                                    img: '14k.jpg',
                                    second: '136'
                                },
                                {
                                    img: '14l.jpg',
                                    second: '162'
                                },
                                {
                                    img: '14m.jpg',
                                    second: '175'
                                },
                                {
                                    img: '14n.jpg',
                                    second: '185'
                                },
                                {
                                    img: '14o.jpg',
                                    second: '205'
                                },
                            ],
                        },
                    ],
            }
            ,
            {
                img: 'barra_6.png',
                title: 'LA FORÇA DE LA REPRESENTACIÓ',
                map: '',
                author: '',
                imageMenu: '',
                imagesAudio: '',
                audio: '',
                menuSubItems:
                    [
                        {
                            img: '',
                            imageMenu: 'sm_15.png',
                            title: 'LA FORÇA DE LA REPRESENTACIÓ',
                            author: '',
                            description: '',
                            audio: '15.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '15a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '15b.jpg',
                                    second: '30'
                                },
                            ],
                        },
                        {
                            img: '',
                            imageMenu: 'sm_16.png',
                            title: 'NOVENARI D\'ÀNIMES',
                            author: '',
                            description: '',
                            audio: '16.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '16a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '16b.jpg',
                                    second: '45'
                                },
                                {
                                    img: '16c.jpg',
                                    second: '100'
                                },
                            ],
                        },
                        {
                            img: '',
                            imageMenu: 'sm_17.png',
                            title: 'BATEIG DE SANT FRANCESC',
                            author: '',
                            description: '',
                            audio: '17.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '17a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '17b.jpg',
                                    second: '108'
                                },
                                {
                                    img: '17c.jpg',
                                    second: '114'
                                },
                            ],

                        },
                        {
                            img: '',
                            imageMenu: 'sm_18.png',
                            title: 'VERGE DE MONTSERRAT',
                            author: '',
                            description: '',
                            audio: '18.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '18a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '18b.jpg',
                                    second: '25'
                                },
                                {
                                    img: '18c.jpg',
                                    second: '85'
                                },
                                {
                                    img: '18d.jpg',
                                    second: '90'
                                },
                            ],
                        },


                        {
                            img: '',
                            imageMenu: 'sm_19.png',
                            title: 'ARBRE DEL ROSER',
                            author: '',
                            description: '',
                            audio: '19.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '19a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '19b.jpg',
                                    second: '118'
                                },
                            ],
                        },
                        {
                            img: '',
                            imageMenu: 'sm_20.png',
                            title: 'SANT FRANCESC XAVIER',
                            author: '',
                            description: '',
                            audio: '20.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '20a.jpg',
                                    second: '0'
                                },
                            ],
                        },
                    ],
            }
            ,
            {
                img: 'barra_7.png',
                title: 'ESCENARIS DEL BARROC',
                map: 'superior.png',
                author: '',
                imageMenu: '',
                imagesAudio: '',
                audio: '',
                menuSubItems:
                    [
                        {
                            img: '',
                            imageMenu: 'sm_21.png',
                            title: 'ESCENARIS DEL BARROC',
                            author: '',
                            description: '',
                            audio: '21.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '21a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '21b.jpg',
                                    second: '58'
                                },
                                {
                                    img: '21c.jpg',
                                    second: '82'
                                },
                            ],
                        },

                        {
                            img: '',
                            imageMenu: 'sm_22.png',
                            title: 'TALLERS MANRESANS',
                            author: '',
                            description: '',
                            audio: '22.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '22a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '22b.jpg',
                                    second: '33'
                                },
                                {
                                    img: '22c.jpg',
                                    second: '40'
                                },
                                {
                                    img: '22d.jpg',
                                    second: '45'
                                },
                                {
                                    img: '22e.jpg',
                                    second: '59'
                                },
                                {
                                    img: '22f.jpg',
                                    second: '79'
                                },
                                {
                                    img: '22g.jpg',
                                    second: '88'
                                },
                            ],
                        },
                        {
                            img: '23a.jpg',
                            imageMenu: 'sm_23.png',
                            title: 'SANT IGNASI A MANRESA',
                            author: '',
                            description: '',
                            audio: '23.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '23a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '23b.jpg',
                                    second: '62'
                                },
                                {
                                    img: '23c.jpg',
                                    second: '69'
                                },
                                {
                                    img: '23d.jpg',
                                    second: '79'
                                },
                                {
                                    img: '23e.jpg',
                                    second: '87'
                                },
                                {
                                    img: '23f.jpg',
                                    second: '99'
                                },

                            ],
                        },
                        {
                            img: '24a.jpg',
                            imageMenu: 'sm_24.png',
                            title: 'FRANCESC PLA',
                            author: '',
                            description: '',
                            audio: '24.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '24a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '24b.jpg',
                                    second: '88'
                                },
                            ],
                        },
                        {
                            img: '25a.jpg',
                            imageMenu: 'sm_25.png',
                            title: 'COMIAT',
                            author: '',
                            description: '',
                            audio: '25.mp3',
                            visitType: '',
                            imagesAudio: [
                                {
                                    img: '25a.jpg',
                                    second: '0'
                                },
                                {
                                    img: '25b.jpg',
                                    second: '14'
                                },
                                {
                                    img: '25c.jpg',
                                    second: '95'
                                },
                                {
                                    img: '25d.jpg',
                                    second: '109'
                                },
                                {
                                    img: '25e.jpg',
                                    second: '117'
                                },
                            ],
                        },

                        {
                            img: '26a.png',
                            imageMenu: 'sm_26.png',
                            title: 'CRÈDITS',
                            author: '',
                            description: 'Guió, producció, disseny i programació: Trama Media.<br><br>Fotografies cedides pel Museu del Barroc de Catalunya.<br><br>Altres imatges:<br>Retaule de la capella del Santíssim de la Basílica de la Seu de Manresa abans del juliol de 1936. Arxiu Comarcal del Bages (Arxiu Gamisans).<br>Retaule de la capella del Roser de Sant Pere Màrtir pels volts de 1925. Publicada al Llibre d’or del Rosari a Catalunya de Valeri Serra i Boldú. Fotografia de Víctor Oliva.<br>Retaule de l\'Altar Major de l\'Església del Carme de Manresa abans del juliol de 1936. Arxiu Comarcal del Bages.<br>Mare de Déu de Montserrat. Departament de Premsa i Comunicació de Montserrat.<br>Gravat de la Flagel·lació (c. 1624/1625) de Jacques Callot. National Gallery of Art, Washington DC.<br>Monument a Antoni Viladomat (1886) al passeig de Lluís Companys de Barcelona, obra de Torquat Tasso. Album / Imago / Steinach.<br><br>Fotografies addicionals:<br>Trama Media.<br><br>Trama Media ha fet tots els possibles per obtenir les autoritzacions necessàries per a tots els continguts reproduïts en aquesta guia. Això no obstant, si voleu formular alguna reclamació relativa a la propietat intel·lectual, no dubteu a posar-vos en contacte amb nosaltres.<br><br>',
                            audio: '',
                            visitType: '{all}',
                            moreInfoItem: '',
                            isCredits: true,

                        },
                    ],
            }
            ,
        ],
    },
}



// WEBPACK FOOTER //
// ./src/data/i18n/catala.js